import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
  Button,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";
import LoadingButton from "../../../components/Common/LoadingButton";
import { UFInput } from "../../../components/Common/Fields/Input";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import closeIcon from "../../../assets/icons/close.svg";
import { toastError, toastSuccess } from "../../../helpers/msg_helper";
import {
  fetchProduct,
  postInventoryProduct,
} from "../../../services/Inventory/inventory"
import MaterialList from "../../../components/Common/chooseFields/materialList"
import Group from "../../../components/Common/chooseFields/group"
import Brands from "../../../components/Common/chooseFields/brands"
import Type from "../../../components/Common/chooseFields/type"
import Unit from "../../../components/Common/chooseFields/unit"
import GroupLi from "../../../components/Common/chooseFields/groupLi"
import { getCode } from "../../../services/inventory";

const schema = yup.object().shape({
  description: yup.string().required("Product Name is Required"),
  // category_id: yup.mixed().required("Category Code is Required"),
  group_id: yup.mixed().required("Product Type is Required"),
  // brand_id: yup.mixed().required("Brand Code is Required"),
  // type_id: yup.mixed().required("Type Code is Required"),
  unit_id: yup.mixed().required("Unit Code is Required"),
  // part_number: yup.string().required("Part Number is Required"),
  price_aed: yup
    .string()
    .required("Sellling Price is required")
    .matches(
      /^([+]?)\d+(\.\d{1,4})?$/,
      "Sellling Price must be a valid number with up to 4 digits after the decimal point"
    ),
  // min_sell_price: yup
  //   .string()
  //   .required("Minimum Selling Price is required")
  //   .matches(
  //     /^([+]?)\d+(\.\d{1,4})?$/,
  //     "Minimum Selling Price must be a valid number with up to 4 digits after the decimal point"
  //   ),
  min_buy_price: yup
    .string()
    .required("Minimum Buying Price is required")
    .matches(
      /^([+]?)\d+(\.\d{1,4})?$/,
      "Buying Price must be a valid number with up to 4 digits after the decimal point"
    ),
});

const Edit = ({ loading, onUpdate, close, getEditValue,editValue, ...props }) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      // category_id: null,
      group_id: null,
      code_edit: 0,
      product_code: "",
      // brand_id: null,
      // type_id: null,
      unit_id: null,
      price_aed: "",
      min_buy_price: "",
      // min_sell_price: "",
      part_number: "",
      description: "",
    },
    mode: "onChange",
    shouldFocusError: true,
  })
  // const methods = useForm({
  //   resolver: yupResolver(schema),
  //   mode: "onChange",
  //   shouldFocusError: true,
  // })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
      const getUniqueCode = async () => {
        const response = await getCode("product_code", "Products", "Products")
        if (editValue?.id == "" || (editValue?.id == undefined && response?.code?.code)) {
          setValue("product_code", response?.code?.code)
        }
        setValue("code_edit", response?.code?.manualoverride)
      }
      getUniqueCode()
    }, [])

  useEffect(() => {
    if (getEditValue) {
      const desimalrange = localStorage.getItem("desimalrange")
      reset({
        ...getEditValue?.data,
        // category_id: {
        //   label: getEditValue?.data?.category?.category_code,
        //   value: getEditValue?.data?.category?.id,
        // },
        group_id: getEditValue?.data?.group?.id ? {
          label: getEditValue?.data?.group?.description,
          value: getEditValue?.data?.group?.id,
        } : null,
        price_aed: getEditValue?.data?.price_aed ? Number(getEditValue?.data?.price_aed).toFixed(desimalrange) : "",
        min_buy_price: getEditValue?.data?.min_buy_price ? Number(getEditValue?.data?.min_buy_price).toFixed(desimalrange) : "",
        // min_sell_price: getEditValue?.data?.min_sell_price ? Number(getEditValue?.data?.min_sell_price).toFixed(desimalrange) : "",
        // brand_id: {
        //   label: getEditValue?.data?.brands?.description,
        //   value: getEditValue?.data?.brands?.id,
        // },
        // type_id: {
        //   label: getEditValue?.data?.types?.description,
        //   value: getEditValue?.data?.types?.id,
        // },
        unit_id: {
          label: getEditValue?.data?.unit?.unit_code,
          value: getEditValue?.data?.unit?.id,
        },
      })
    }
  }, [getEditValue])

  const handleRegistration = async data => {
    try {
      setIsLoading(true)
      const updateDepartment = await postInventoryProduct({
        ...data,
        // category_id: data?.category_id?.value,
        group_id: data?.group_id?.value,
        // min_buy_price: 0,
        min_sell_price: 0,
        // brand_id: data?.brand_id?.value,
        // type_id: data?.type_id?.value,
        unit_id: data?.unit_id?.value,
      });
      toastSuccess(updateDepartment?.message);
      onUpdate(updateDepartment.data); // Pass the new product data back
      close();
    } catch (err) {
      toastError(err?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <OffcanvasHeader className="d-flex justify-content-between align-items-center">
        <div className="d-flex justify-content-between w-100">
          <h5 className="editmodelheadtitle m-0 edittheamtitle">
            {getEditValue?.data?.id ? "Edit Product" : "Add Product"}
          </h5>
          <div className="d-flex gap-2">
          <Button
              color="secondary"
              onClick={close}
              size="sm"
            >
              Close
            </Button>
            <LoadingButton
              form={`product-form`}
              color={"primary"}
              loading={isLoading}
              disabled={isLoading}
              type="submit"
              size="sm"
            >
              {getEditValue?.data?.id ? "Update" : "Save"}
            </LoadingButton>
           
          </div>
        </div>
      </OffcanvasHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
         size="md"
          />
        </div>
      ) : (
        <>
          <OffcanvasBody>
            <FormProvider>
              <Form id={`product-form`} onSubmit={(e) => {  e.preventDefault();
                  e.stopPropagation();
                  handleSubmit(handleRegistration)(e) }}>
                  
                <Row>
                  {/* <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Category Code<span className="mandatory">*</span>
                      </Label>
                      <MaterialList
                        control={control}
                        name={"category_id"}
                        invalid={!!errors.category_id}
                        disabled={getEditValue?.data?.id}
                      />
                      <FormFeedback invalid>
                        {errors.category_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col> */}
                  <Col sm={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Code</Label>
                                      <UFInput
                                        control={control}
                                        placeholder=""
                                        name={"product_code"}
                                        invalid={!!errors.product_code}
                                        disabled={
                                          watch("code_edit") == 0 ||
                                          watch("code_edit") == undefined
                                            ? true
                                            : false
                                        }
                                      />
                                      <FormFeedback invalid>
                                        {errors.product_code?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                  <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Product Name<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Product Name"
                        rows="3"
                        name={"description"}
                        invalid={!!errors.description}
                      />
                      <FormFeedback invalid>
                        {errors.description?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Group<span className="mandatory">*</span>
                      </Label>
                      {/* <GroupLi
                        control={control}
                        name={"group_id"}
                        invalid={!!errors.group_id}
                      /> */}
                      <Group
                        control={control}
                        name={"group_id"}
                        invalid={!!errors.group_id}
                        placeholder={"Select the Group"}
                      />
                      <FormFeedback invalid>
                        {errors.group_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  {/* <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Brand Code
                      </Label>
                      <Brands
                        control={control}
                        name={"brand_id"}
                        invalid={!!errors.brand_id}
                      />
                      <FormFeedback invalid>
                        {errors.brand_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Type Code
                      </Label>
                      <Type
                        control={control}
                        name={"type_id"}
                        invalid={!!errors.type_id}
                      />
                      <FormFeedback invalid>
                        {errors.type_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col> */}
                  <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Unit Code<span className="mandatory">*</span>
                      </Label>
                      <Unit
                        control={control}
                        name={"unit_id"}
                        invalid={!!errors.unit_id}
                        placeholder="Select the Unit Code"
                      />
                      <FormFeedback invalid>
                        {errors.unit_id?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Sellling Price (AED)<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Price"
                        rows="3"
                        name={"price_aed"}
                        invalid={!!errors.price_aed}
                      />
                      <FormFeedback invalid>
                        {errors.price_aed?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Buying Price (AED)<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Price"
                        rows="3"
                        name={"min_buy_price"}
                        invalid={!!errors.min_buy_price}
                      />
                      <FormFeedback invalid>
                        {errors.min_buy_price?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  {/* <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Min Selling Price (AED)<span className="mandatory">*</span>
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Price"
                        rows="3"
                        name={"min_sell_price"}
                        invalid={!!errors.min_sell_price}
                      />
                      <FormFeedback invalid>
                        {errors.min_sell_price?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col> */}
                  <Col sm={6}>
                    <FormGroup className="mb-4">
                      <Label>
                        Part Number
                      </Label>
                      <UFInput
                        control={control}
                        placeholder="Enter the Part Number"
                        rows="3"
                        name={"part_number"}
                        invalid={!!errors.part_number}
                      />
                      <FormFeedback invalid>
                        {errors.part_number?.message}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  
                </Row>
              </Form>
            </FormProvider>
          </OffcanvasBody>
        </>
      )}
    </>
  );
};

const EditProduct = ({ buttonLabel, className, isOpen, onClose, onProductCreated, editValue, ...props }) => {
  const [canvas, setCanvas] = useState(false);
  const [getEditValue, setGetEditValue] = useState("");
console.log(`editValue`, editValue);

  const toggle = () => {
    if (isOpen !== undefined) {
      onClose?.();
    } else {
      setCanvas(!canvas);
    }
  };

  const handleSuccess = (data) => {
    onProductCreated?.(data); // Call this when product is successfully created
    onClose?.();
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchProduct(editValue?.id);
      if (response?.status) {
        setGetEditValue(response);
      }
    };
    
    if (editValue?.id) {
      fetchData();
      setCanvas(true)
    }
    
    if (isOpen !== undefined) {
      setCanvas(isOpen);
    }
  }, [editValue?.id, isOpen]);

  const isOpenState = isOpen !== undefined ? isOpen : canvas;

  return (
    <>
      {buttonLabel && (
        <Link to="#" className={className} onClick={toggle}>
          {buttonLabel}
        </Link>
      )}
      <Offcanvas 
        isOpen={isOpenState} 
        toggle={toggle} 
        direction="end"
        className="w-md-50 w-lg-40"
        backdrop={false}
        keyboard={false}
      >
        <Edit
          close={() => {
            toggle();
            setCanvas(false);
            setGetEditValue("");
            props?.onReset?.();
          }}
          getEditValue={getEditValue}
          editValue={editValue}
          onUpdate={handleSuccess}
          {...props}
        />
      </Offcanvas>
    </>
  );
};

export default EditProduct;